module.exports = __webpack_public_path__ + "static/media/logo.0ba450f4.png";